import { render } from "./ChecklistEdit.vue?vue&type=template&id=22963428"
import script from "./ChecklistEdit.vue?vue&type=script&lang=js"
export * from "./ChecklistEdit.vue?vue&type=script&lang=js"
script.render = render

export default script